
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|2337|3023|9795)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
